export const CHOOSE_DATA_SOURCE_TOPIC_MODAL_STATE = 'choose_data_source_topic_modal_state';
export const KEYWORD_FILTERING_TOPIC_MODAL_STATE = 'keyword_filtering_topic_modal_state';
export const UPLOAD_DATA_TOPIC_DETAILS_MODAL_STATE = 'upload_data_topic_modal_state';
export const UPLOAD_FILES_MODAL_STATE = 'upload_files_modal_state';
export const DATA_SUMMARY_WITH_ERRORS_MODAL_STATE = 'data_summary_with_errors_modal_state';
export const DATA_SUMMARY_MODAL_STATE = 'data_summary_modal_state';
export const LOADING_MODAL_STATE = 'loading_modal_state';
export const REMOVE_ROWS_WITH_ERRORS_CONFIRMATION_STATE = 'remove_rows_with_errors_confirmation_state';
export const CONFIRM_CANCEL_TOPIC_CREATION_STATE = 'confirm_cancel_topic_creation_state';
export const EDIT_TOPIC_MODAL_STATE = 'edit_topic_modal_state';

export const TOPIC_NAME_MISSING_ERROR_KEY = 'topicNameMissing';
export const TOPIC_NAME_EXISTS_ERROR_KEY = 'topicNameAlreadyExists';
export const CATEGORIES_KEY = 'categories';
export const DESCRIPTION_KEY = 'description';
export const MAXIMUM_DESCRIPTION_LENGTH = 150;
export const MAXIMUM_TOPIC_NAME_LENGTH = 50;
export const MAXIMUM_CONTENT_CHARACTERS = 65535;

export const CONTENT_KEY           = "content";
export const DATE_KEY              = "date";
export const SOURCE_KEY            = "source";
export const COLUMNS_KEY           = "columns";
export const SOURCE_LINK_KEY       = "source_link";
export const UPLOAD_FILE_IN_CSV_FORMAT = "text/csv";

export const DATE_TIME_IN_YYYY_MM_DD_FORMAT = 'YYYY-MM-DD';
export const LOCAL_STORAGE_KEY_FOR_DO_NOT_SHOW_REMOVE_ROWS_CONFIRMATION = "hasCheckedDoNotShowRemoveRowsConfirmation";

export const MODAL_STATES_REQUIRING_CANCEL_CONFIRMATION = [
  UPLOAD_FILES_MODAL_STATE,
  DATA_SUMMARY_WITH_ERRORS_MODAL_STATE,
  DATA_SUMMARY_MODAL_STATE,
  LOADING_MODAL_STATE,
  REMOVE_ROWS_WITH_ERRORS_CONFIRMATION_STATE
];

export const EDIT_TOPIC_TYPE_TAG = 'edit';
export const ADD_UPLOADED_TOPIC_TYPE_TAG = 'add_uploaded_topic';

export const MAXIMUM_NUMBER_OF_ROWS_IN_UPLOADED_FILE = 100000;
export const MAXIMUM_FILE_SIZE_IN_KB = 51200;


// WEBPACK FOOTER //
// ./src/features/topics/components/constants/constants.js